const ARTICLE_CATEGORY_ABOUT_IGNITE = 1;
const ARTICLE_CATEGORY_PDR_NEWS = 2;
const ARTICLE_CATEGORY_HOW_TO_EARN = 16;

export default {
  excludedCategoryIds: [ARTICLE_CATEGORY_ABOUT_IGNITE, ARTICLE_CATEGORY_PDR_NEWS, ARTICLE_CATEGORY_HOW_TO_EARN]
};
